import UserInfoAvatar from '@Components/UserInfoAvatar'
import Button from '@Components/Buttons/Button'
import React from 'react'
import { UserInfo } from '@Entities/user/user'

interface TopSectionProps {
    userInfo: UserInfo
    isInternal: boolean
    onClick(): void
}

const TopSection = (props: TopSectionProps) => {
    const { userInfo, isInternal, onClick } = props
    return (
        <div className="profile-info">
            <UserInfoAvatar userInfo={userInfo} />
            {!isInternal && (
                <Button mainColor type="primary" onClick={onClick}>
                    Edit
                </Button>
            )}
        </div>
    )
}
export default TopSection
